"use strict";
module.exports = {
    entityModel: 'entitySettlement',
    events: {
        ENTITY_SETTLEMENT_CREATED: 'ENTITY_SETTLEMENT_CREATED',
        ENTITY_SETTLEMENT_UPDATED: 'ENTITY_SETTLEMENT_UPDATED',
    },
    actions: {
        get: 'v1.entitySettlement.get',
        list: 'v1.entitySettlement.list',
        upsertManualEntitySettlement: 'v1.entitySettlement.upsertManualEntitySettlement',
        createEntitySettlementFromOrderCorrection: 'v1.entitySettlement.createEntitySettlementFromOrderCorrection',
        cancel: 'v1.entitySettlement.cancel',
        ensureBasedOnOrder: 'v1.entitySettlement.ensureBasedOnOrder',
        ensureBasedOnComplaint: 'v1.entitySettlement.ensureBasedOnComplaint',
        ensureBasedOnPurchaseOrder: 'v1.entitySettlement.ensureBasedOnPurchaseOrder',
        upsert: 'v1.entitySettlement.upsert',
        upsertWhenEmpty: 'v1.entitySettlement.upsertWhenEmpty',
        updateWhenEmpty: 'v1.entitySettlement.updateWhenEmpty',
        update: 'v1.entitySettlement.update',
    },
    entityTypes: {
        order: 'order',
        purchaseOrder: 'purchaseOrder',
        complaint: 'complaint',
        manual: 'manual',
        alcoholTaxAdjustment: 'alcoholTaxAdjustment',
    },
};
